<template>
  <div>
    <b-card
      id="container"
      ref="container"
    >
      <b-card-text class="mb-2">
        <h5>
          {{ $t('pages.voiceAlertSettings.desc') }}
        </h5>
      </b-card-text>
      <text-editor
        :id="newServiceTicker.id"
        :key="0"
        v-model.lazy="newServiceTicker.options"
        :title="$t('pages.voiceAlertSettings.voiceAlertNewServiceTicketSpecific.title')"
        :desc="$t('pages.voiceAlertSettings.voiceAlertNewServiceTicketSpecific.desc')"
        :param-options="[
          {
            label: 'operator_name_desc',
            value: '{{operatorName}}'
          }
        ]"
        class="mb-2"
        @update:textEditor="onUpdateTextEditor"
        @update:enable="onUpdateEnable"
      />

      <text-editor
        :id="voiceAlertPendingPriceMerchant.id"
        :key="1"
        v-model.lazy="voiceAlertPendingPriceMerchant.options"
        :title="$t('pages.voiceAlertSettings.voiceAlertPendingPriceMerchant.title')"
        :desc="$t('pages.voiceAlertSettings.voiceAlertPendingPriceMerchant.desc')"
        :time-notify-desc="
          $t('pages.voiceAlertSettings.voiceAlertPendingPriceMerchant.notify.desc')
        "
        :param-options="[
          {
            label: 'operator_name_desc',
            value: '{{operatorName}}'
          },
          {
            label: 'count_unread_desc',
            value: '{{countLateReplyMessage}}'
          },
          {
            label: 'channel_name_desc',
            value: '{{channelName}}'
          }
        ]"
        class="mb-2"
        @update:textEditor="onUpdateTextEditor"
        @update:enable="onUpdateEnable"
      />

      <text-editor
        :id="voiceAlertPendingPriceSpecific.id"
        :key="2"
        v-model.lazy="voiceAlertPendingPriceSpecific.options"
        :title="$t('pages.voiceAlertSettings.voiceAlertPendingPriceSpecific.title')"
        :desc="$t('pages.voiceAlertSettings.voiceAlertPendingPriceSpecific.desc')"
        :time-notify-desc="
          $t('pages.voiceAlertSettings.voiceAlertPendingPriceSpecific.notify.desc')
        "
        :param-options="[
          {
            label: 'operator_name_desc',
            value: '{{operatorName}}'
          },
          {
            label: 'service_ticket_id',
            value: '{{serviceTicketId}}'
          }
        ]"
        class="mb-2"
        @update:textEditor="onUpdateTextEditor"
        @update:enable="onUpdateEnable"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'
import VoiceAlertSettingsRepository from '@/repositories/Api/VoiceAlertSettingsRepository'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import TextEditor from './SpeechAlertTextEditor.vue'

const ServiceSystemRepository = RepositoryFactory.get('serviceSystem')

export default {
  components: {
    BCard,
    BCardText,
    TextEditor,
  },

  data: () => ({
    data: [],
    newServiceTicker: {
      id: '',
      title: '',
      desc: '',
      options: {
        enable: false,
        locales: {
          en: 'Hello',
          zh: '',
        },
      },
    },
    voiceAlertPendingPriceMerchant: {
      id: '',
      title: '',
      desc: '',
      options: {
        sendAfter: 60,
        enable: false,
        locales: {
          en: 'Hello',
          zh: '',
        },
      },
    },
    voiceAlertPendingPriceSpecific: {
      id: '',
      title: '',
      desc: '',
      options: {
        enable: false,
        locales: {
          en: 'Hello',
          zh: '',
        },
      },
    },
  }),
  mounted() {
    this.getAlertVoiceSettings()
  },
  methods: {
    async getAlertVoiceSettings() {
      try {
        const response = await ServiceSystemRepository.getVoiceSetting()
        const { data } = response.data

        this.data = data
        this.newServiceTicker = this.mappingData('action.voiceAlertNewServiceTicketSpecific')
        this.voiceAlertPendingPriceMerchant = this.mappingData(
          'action.voiceAlertPendingPriceMerchant',
        )
        this.voiceAlertPendingPriceSpecific = this.mappingData(
          'action.voiceAlertPendingPriceSpecificOperator',
        )
      } catch (err) {
        const { data } = err.response
        const { message } = data
        if (message === 'error.recordNotFound') await this.createDefaultChatSettings()
      }
    },
    async createDefaultChatSettings() {
      try {
        await VoiceAlertSettingsRepository.show()
        await this.getAlertVoiceSettings()
      } catch (err) {
        alert(err)
      }
    },
    async updateVoiceAlertSettings(payloadUpdate, id) {
      try {
        await ServiceSystemRepository.updateVoiceSetting(
          id,
          payloadUpdate,
        )
      } catch (err) {
        alert(err)
      } finally {
        await this.getAlertVoiceSettings()
      }
    },
    async onUpdateEnable(event) {
      console.log('event', event)
      const payload = {
        enable: event.enable,
        message: event.locales,
      }
      this.updateVoiceAlertSettings(payload, event.id)
    },
    async onUpdateTextEditor(event) {
      const payload = {
        notifySend: event?.sendAfter,
        message: event.locales,
      }
      this.updateVoiceAlertSettings(payload, event.id)
    },
    mappingData(codeAction) {
      const filterData = this.data.filter(item => item.code == codeAction)
      const settingMsg = filterData[0]
      const code = 'action.voiceAlertMerchantNoResponse'

      const response = {
        id: settingMsg.id,
        title: settingMsg.title,
        desc: settingMsg.description,
        options: {
          enable: settingMsg.enable,
          sendAfter: codeAction == code ? settingMsg?.notifySend : undefined,
          locales: {
            en: settingMsg.message.en,
            zh: settingMsg.message.zh,
          },
        },
      }
      if (codeAction == 'action.end') {
        delete response.options.sendAfter
        response.options.closeTime = settingMsg.notifySend
      } else if (codeAction == 'action.endManual') {
        delete response.options.sendAfter
      }
      return response
    },
  },
  setup() {
    const permissionType = 'voice-settings'
    return { permissionType }
  },
}
</script>
<style lang="css" scoped>
:deep(textarea) {
  resize: none;
  width: 600px !important;
}
</style>
